import getV10APIs from './v1.0';
import { mergeVersionsByTitle } from '../../../util/HelperFunctions';

const data = (userInfo) => {
  const v10APIs = getV10APIs(userInfo);

  const children = [
    mergeVersionsByTitle('고객문의 조회', v10APIs),
    mergeVersionsByTitle('문의답변 등록', v10APIs),
  ].filter(Boolean);

  return { title: '문의', children };
};

export default data;
